export default __webpack_public_path__ + "static/media/backup-wallet-24.94bc91a4.webp";